import React from "react";
import Page from "../templates/conserve/waste/wastepage";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Fabric Waste Management | Sustainability Practices | Hirdaramani
        </title>
        <meta
          name="title"
          content="Fabric Waste Management | Sustainability Practices | Hirdaramani"
        />
        <meta
          name="description"
          content="Discover how Hirdaramani achieves targets in fabric waste reduction. Check our future targets and the currently achieved targets."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/conserve/waste/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Fabric Waste Management" />
        <meta
          property="og:title"
          content="Fabric Waste Management | Sustainability Practices | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Discover how Hirdaramani achieves targets in fabric waste reduction. Check our future targets and the currently achieved targets."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/conserve/waste/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
